<template>
  <DeleteConfirm
      itemKey="Tariff"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tariffs from '@/services/tariffs'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Tariffs
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť tarifu "' + Item.title + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť tarifu "' + Item.title + '"?'
      },
      deleteData() {
        return Tariffs
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
